(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card"] && !Shopify.designMode) return;
  try {
    /*
   * BUY NOW
   *
   * Opens the product details page.
   * Does NOT add the product to cart.
   * Does NOT open checkout.
   */

  document.addEventListener('click', function (event) {

    const button = event.target.closest('.lux-card__buy-now');

    if (!button) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const productUrl = button.dataset.productUrl;

    if (!productUrl) {
      return;
    }

    window.location.href = productUrl;

  });
  } catch(e) { console.error(e); }
})();

})();
